export enum EntityType {
    Course = 1,
    Program = 2,
    ILT = 3,
    MyLearning = 4,
    Conversation = 5,
    Survery = 6,
    Video = 7,
    Briefcase = 8,
}